import { AddressModel } from "../address.model"
import { ContactBaseModel } from "./contact-base.model";

export class ContactModel extends ContactBaseModel {

    address: AddressModel = new AddressModel();
    customFields?: string;   
}
